function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from './Wrapper';
import FeedbackForm from './FeedbackForm';
import ThankyouView from './ThankyouView';
var BetaNpsForm = function (_React$Component) {
  _inherits(BetaNpsForm, _React$Component);
  function BetaNpsForm(props) {
    _classCallCheck(this, BetaNpsForm);
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
    _this.state = {
      isSubmitted: false,
      comment: ''
    };
    _this.onScoreSelect = _this.onScoreSelect.bind(_this);
    _this.onFeedbackSubmit = _this.onFeedbackSubmit.bind(_this);
    _this.onCommentChange = _this.onCommentChange.bind(_this);
    return _this;
  }
  BetaNpsForm.prototype.onScoreSelect = function onScoreSelect(score) {
    this.setState({
      score: score
    });
  };
  BetaNpsForm.prototype.onFeedbackSubmit = function onFeedbackSubmit(e) {
    var _this2 = this;
    e.preventDefault();
    var me = this.props.me;
    var _state = this.state,
      score = _state.score,
      comment = _state.comment;
    var payload = {
      date: new Date().toISOString(),
      full_name: me.firstName + ' ' + me.lastName,
      email: me.primaryEmail,
      member_id: me.id,
      account_type: me.type,
      nps_score: score,
      nps_comment: comment,
      url: window.location.href
    };
    var options = {
      body: JSON.stringify(payload),
      method: 'POST'
    };
    var url = 'https://hooks.zapier.com/hooks/catch/4140728/cs3ext/';
    window.fetch(url, options).then(function () {
      return _this2.setState({
        isSubmitted: true,
        comment: '',
        score: null
      });
    }).catch(function () {
      return _this2.setState({
        isSubmitted: true,
        comment: '',
        score: null
      });
    });
  };
  BetaNpsForm.prototype.onCommentChange = function onCommentChange(event) {
    this.setState({
      comment: event.target.value
    });
  };
  BetaNpsForm.prototype.render = function render() {
    var _state2 = this.state,
      score = _state2.score,
      comment = _state2.comment,
      isSubmitted = _state2.isSubmitted;
    var intercom = this.props.intercom;
    return intercom ? React.createElement(Wrapper, null, React.createElement(FeedbackForm, {
      hide: isSubmitted,
      onFormSubmit: this.onFeedbackSubmit,
      onScoreSelect: this.onScoreSelect,
      onCommentChange: this.onCommentChange,
      comment: comment,
      score: score
    }), React.createElement(ThankyouView, {
      open: isSubmitted
    })) : null;
  };
  return BetaNpsForm;
}(React.Component);
BetaNpsForm.propTypes = process.env.NODE_ENV !== "production" ? {
  intercom: PropTypes.func.isRequired,
  me: PropTypes.object.isRequired
} : {};
export default BetaNpsForm;